const styles = {
  wrapper: (color: string) => ({
    width: {
      md: "300px",
      xxl: "600px",
    },
    height: {
      md: "300px",
      xxl: "600px",
    },
    position: "absolute",
    top: "50%",
    left: {
      xs: "70%",
      xl: "50%",
    },
    transform: {
      xs: "translate(-70%, -50%)",
      xl: "translate(-50%, -50%)",
    },
    zIndex: 1600,
    display: {
      xs: "none",
      md: "inline-block",
    },
    "@keyframes animloader": {
      "0%": {
        transform: "translate(-50%, -50%) scale(0)",
        opacity: 0.4,
      },
      "100%": {
        transform: "translate(-50%, -50%) scale(1)",
        opacity: 0,
      },
    },
    "@keyframes dotsAnim": {
      "0%": {
        boxShadow: `-68px -6px 0 0 ${color}, -26px 6px 0 0 ${color}, 18px -6px 0 0 ${color}`,
      },
      "33%": {
        boxShadow: `-68px 6px 0 0 ${color}, -26px -6px 0 0 ${color}, 18px 6px 0 0 ${color}`,
      },
      "66%": {
        boxShadow: `-68px -6px 0 0 ${color}, -26px 6px 0 0 ${color}, 18px -6px 0 0 ${color}`,
      },
      "100%": {
        boxShadow: `-68px 6px 0 0 ${color}, -26px -6px 0 0 ${color}, 18px 6px 0 0 ${color}`,
      },
    },
  }),
  firstCircle: (color: string) => ({
    boxSizing: "border-box",
    width: {
      md: "300px",
      xxl: "600px",
    },
    height: {
      md: "300px",
      xxl: "600px",
    },
    borderRadius: "50%",
    background: color,
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    animation: "animloader 2s linear infinite",
    opacity: 0.2,
  }),
  secondCircle: (color: string) => ({
    boxSizing: "border-box",
    width: {
      md: "300px",
      xxl: "600px",
    },
    height: {
      md: "300px",
      xxl: "600px",
    },
    borderRadius: "50%",
    background: color,
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    animation: "animloader 2s linear infinite",
    animationDelay: "1s",
    opacity: 0.2,
  }),
  dotsLoader: (color: string) => ({
    width: {
      md: "16px",
    },
    height: {
      md: "16px",
    },
    borderRadius: "50%",
    display: "block",
    position: "absolute",
    left: "53%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    color: color,
    boxSizing: "border-box",
    animation: "dotsAnim 2s linear infinite alternate",
    zIndex: 2,
    filter: "brightness(1.5) drop-shadow(0 0 3px rgba(0, 176, 255, 0.7))",
  }),
};

export default styles;
